module.exports = __webpack_public_path__ + "img/02.369046e1.jpg";